import { getColumnsByNames } from './all-top10-columns-config';

export const topBlockDnsCategories = getColumnsByNames([
    { name: 'category', width: '35%' },
    { name: 'count', width: '62%' }
]);